import "./assets/styles/main.css";

import { createApp } from "vue";
import { createPinia } from "pinia";
//import * as Sentry from "@sentry/vue";

import App from "./App.vue";
import router from "./router";

const app = createApp(App);

// Initialize Sentry
// Sentry.init({
//   app,
//   dsn: "https://31118c3bfc17380601764ea835cc4b56@o4507766920642560.ingest.us.sentry.io/4508253989437440",
//   integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
//   tracesSampleRate: 1.0,
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1.0,
// });

app.use(createPinia());
app.use(router);

app.mount("#app");
